interface FormActionsProps {
  onCancel: () => void;
  isLoading?: boolean;
  submitText?: string;
  cancelText?: string;
}

const FormActions = ({
  onCancel,
  isLoading,
  submitText = "Salvar",
  cancelText = "Cancelar",
}: FormActionsProps) => (
  <div className="flex justify-end space-x-3 pt-4">
    <button
      type="button"
      onClick={onCancel}
      className="rounded-md bg-neutral-200 px-4 py-2 text-neutral-700 hover:bg-neutral-300"
    >
      {cancelText}
    </button>
    <button
      type="submit"
      disabled={isLoading}
      className="rounded-md bg-primary px-4 py-2 text-white hover:bg-primary-dark disabled:opacity-50"
    >
      {isLoading ? "Salvando..." : submitText}
    </button>
  </div>
);

export default FormActions;
